function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 5218"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 153577",
    style: {
      fill: "none"
    },
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.925-848.188.888-.888-3.181-3.181v-3.955h-1.263v4.466zM108-844a7.794 7.794 0 0 1-3.12-.63 8.08 8.08 0 0 1-2.541-1.71 8.079 8.079 0 0 1-1.711-2.54A7.786 7.786 0 0 1 100-852a7.794 7.794 0 0 1 .63-3.12 8.081 8.081 0 0 1 1.71-2.541 8.081 8.081 0 0 1 2.54-1.711A7.787 7.787 0 0 1 108-860a7.794 7.794 0 0 1 3.12.63 8.081 8.081 0 0 1 2.541 1.71 8.08 8.08 0 0 1 1.711 2.54A7.786 7.786 0 0 1 116-852a7.794 7.794 0 0 1-.63 3.12 8.081 8.081 0 0 1-1.71 2.541 8.078 8.078 0 0 1-2.54 1.711A7.786 7.786 0 0 1 108-844zm0-8zm0 6.737a6.494 6.494 0 0 0 4.768-1.968 6.494 6.494 0 0 0 1.969-4.769 6.494 6.494 0 0 0-1.968-4.768 6.494 6.494 0 0 0-4.769-1.969 6.494 6.494 0 0 0-4.768 1.968 6.494 6.494 0 0 0-1.969 4.769 6.494 6.494 0 0 0 1.968 4.768 6.494 6.494 0 0 0 4.769 1.969z",
    transform: "translate(-98 862)",
    style: {
      fill: "#909090"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.6f0ccaf69f9825526bc4b93e81b866a2.svg";
export { ForwardRef as ReactComponent };